declare namespace $ {

	type $mol_text__text_our_app_org_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_our_app_org_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_page__title_our_app_org_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_org_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_org_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_textarea__hint_our_app_org_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_button_major__title_our_app_org_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_list__rows_our_app_org_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_our_app_org_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_org_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_org_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_our_app_org_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_list__rows_our_app_org_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_page__title_our_app_org_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_org_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_text__text_our_app_org_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_our_app_org_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_our_app_org_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	export class $our_app_org extends $mol_book2_catalog {
		Show_text( ): $mol_text
		Show_add( ): $mol_button_major
		Show( ): $mol_page
		Game_1( ): $mol_text
		Game_feedback( ): $mol_textarea
		Game_feedback_add( ): $mol_button_major
		Games_list( ): $mol_list
		Games( ): $mol_page
		Feedback_text( ): $mol_text
		Feedback_game( ): $mol_text
		Feedback_list( ): $mol_list
		Feedback( ): $mol_page
		Request_text( ): $mol_text
		Request( ): $mol_page
		menu_title( ): string
		spreads( ): ({ 
			'show': ReturnType< $our_app_org['Show'] >,
			'games': ReturnType< $our_app_org['Games'] >,
			'feedback': ReturnType< $our_app_org['Feedback'] >,
			'request': ReturnType< $our_app_org['Request'] >,
		}) 
	}
	
}

//# sourceMappingURL=org.view.tree.d.ts.map